import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./userList.css";

function HourlyUserList() {
  const [allUsers, setAllUsers] = useState([]); // Stores all users
  const [users, setUsers] = useState([]); // Stores users for the current page
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const usersPerPage = 15; // Show 15 users per page
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data using Axios
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/hourlyUserList`);
        setAllUsers(response.data);
        setTotalPages(Math.ceil(response.data.length / usersPerPage)); // Calculate total pages
      } catch (err) {
        setError(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    // Filter users based on search query
    let filteredUsers = allUsers;
    if (searchQuery.trim() !== "") {
      filteredUsers = allUsers.filter((user) =>
        user.vehicleNumber.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Update the displayed users based on the current page
    const indexOfLastUser = page * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    setUsers(filteredUsers.slice(indexOfFirstUser, indexOfLastUser));

    setTotalPages(Math.ceil(filteredUsers.length / usersPerPage));
  }, [page, allUsers, searchQuery]);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // ✅ Function to navigate to User Details page
  const goToUserDetails = (id) => {
    navigate(`/adminDashboard/hourlyParkingUserDetail/${id}`);
  };

  return (
    <div className="hourlyUserList">
      <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>⬅ Back</button>
      <h1>Hourly Parking User List</h1>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="container tableSection table-responsive">
          {/* Search Bar */}
          <div className="d-flex justify-content-center">
            <div className="input-group" style={{ width: "500px", marginTop: "20px" }}>
              <input
                className="form-control form-control-lg"
                type="search"
                placeholder="Search by Vehicle Number"
                aria-label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="btn btn-primary px-4" type="button">
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>

          {/* Table */}
          <table className="container table table-hover table-bordered">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Customer Name</th>
                <th>Contact Number</th>
                <th>Email</th>
                <th>Vehicle Number</th>
                <th>Vehicle Type</th>
                <th>Parking Slot</th>
                <th>Entry Time</th>
                <th>Entry Date</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => (
                  <tr
                    key={user._id}
                    onClick={() => goToUserDetails(user._id)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{(page - 1) * usersPerPage + index + 1}</td>
                    <td>{user.customerName}</td>
                    <td>{user.contactNumber}</td>
                    <td>{user.email || "N/A"}</td>
                    <td>{user.vehicleNumber.toUpperCase()}</td>
                    <td>{user.vehicleType}</td>
                    <td>{user.parkingSlot}</td>
                    <td>{user.entryTime}</td>
                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">No users found</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {users.length > 0 && (
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
                  Previous
                </button>
              </li>

              {/* Page Numbers */}
              {[...Array(totalPages)].map((_, index) => (
                <li key={index} className={`page-item ${page === index + 1 ? "active" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                    {index + 1}
                  </button>
                </li>
              ))}

              {/* Next Button */}
              <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
                  Next
                </button>
              </li>
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default HourlyUserList;
